import { render, staticRenderFns } from "./user-resetpwd.vue?vue&type=template&id=e8c77102"
import script from "./user-resetpwd.vue?vue&type=script&lang=js"
export * from "./user-resetpwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports